import api from "@/api";
import { ElMessage } from "element-plus";
import OssUploader from "@/components/OssUploader.vue";
import DialogCustomView from "@/components/DialogCustomView.vue";
export default {
  name: "SiteConfigView",
  components: {
    DialogCustomView,
    OssUploader
  },
  data() {
    return {
      siteId: this.$route.params.siteId,
      configList: [],
      siteName: null,
      previewImg: null,
      previewImgVisible: false
    };
  },
  methods: {
    previewCfg(cfg) {
      this.previewImg = cfg.configValue;
      this.previewImgVisible = true;
    },
    isImg(u) {
      if (!u) {
        return false;
      }
      return !!(u.startsWith('http') && (u.toLowerCase().endsWith('jpg') || u.toLowerCase().endsWith('jpeg') || u.toLowerCase().endsWith('png') || u.toLowerCase().endsWith('gif')));
    },
    init() {
      api.getSiteConfigList(this.siteId).then(ret => {
        this.configList = ret;
      });
      api.getEnumValueById(this.siteId).then(ret => {
        this.siteName = ret.label;
      });
    },
    updateWithUrl(url, cfg) {
      cfg.configValue = url;
      this.updateConfig(cfg);
    },
    updateConfig(cfg) {
      api.createOrUpdateSiteConfig(cfg).then(() => {
        ElMessage.success('更新成功');
        // this.init()
      });
    }
  },
  mounted() {
    this.init();
  }
};